import TableContainer from "components/tables/TableContainer"
import React, { useMemo } from "react"
import { Input } from "reactstrap"

const TableOrderDetail = ({ content }) => {
  const columns = useMemo(
    () => [
      {
        Header: "RTW商品番号",
        accessor: "rtw_product_number",
        Cell: () => {
          return <Input type="text" className="w-100" />
        },
      },
      {
        Header: "商品名",
        accessor: "product_name",
      },
      {
        Header: "単価",
        accessor: "unit_price",
      },
      {
        Header: "数",
        accessor: "number",
        Cell: () => {
          return <Input type="text" className="w-50" />
        },
      },
      {
        Header: "割引",
        accessor: "discount",
        Cell: () => {
          return <Input type="text" className="w-100" />
        },
      },
      {
        Header: "合計金額",
        accessor: "total_amount",
        Cell: () => {
          return <Input type="text" className="w-100" />
        },
      },
    ],
    []
  )

  const listDataTable = useMemo(() => {
    if (!content) return []
    return content.map((v, i) => ({
      rtw_product_number: v.rtw_product_number,
      product_name: v.product_name,
      unit_price: v.unit_price,
      number: v.number,
      discount: v.discount,
      total_amount: v.total_amount,
    }))
  }, [content])

  return (
    <>
      <TableContainer
        columns={columns}
        data={listDataTable}
        pagination={false}
      />
    </>
  )
}

export default TableOrderDetail
